/**
 * useDeviceSync — V2.N.4
 *
 * Déclenche le mirroring des données locales vers la base :
 *   - 1× au mount de l'app (capture l'état au chargement)
 *   - à chaque login/logout (pour rattacher/détacher le device du
 *     compte)
 *
 * À monter UNE fois dans AppContent. Les mutations ponctuelles
 * (ajout wallet, token, toggle page) appellent directement
 * scheduleDeviceSync() depuis leurs hooks respectifs.
 */

import { useEffect, useRef } from 'react';
import { useAuthStore } from '../store/authStore';
import { scheduleDeviceSync, syncDeviceNow } from '../services/deviceSyncService';

export function useDeviceSync() {
  const { isAuthenticated, user } = useAuthStore();
  const didInitialSync = useRef(false);
  const lastUserId = useRef<string | null>(null);

  // Sync initial au mount (debouncé pour laisser l'app s'hydrater).
  useEffect(() => {
    if (didInitialSync.current) return;
    didInitialSync.current = true;
    scheduleDeviceSync();
  }, []);

  // Sync immédiat à chaque changement d'identité (login/logout) pour
  // rattacher ou détacher le device du compte.
  useEffect(() => {
    const currentUserId = isAuthenticated ? user?.id ?? null : null;
    if (currentUserId !== lastUserId.current) {
      lastUserId.current = currentUserId;
      // Au login, on force un sync immédiat pour lier le device au
      // compte sans attendre le debounce.
      syncDeviceNow();
    }
  }, [isAuthenticated, user?.id]);
}
